import React, { useState } from 'react';
import { Box, Button, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const dummyCustomers = [
    { id: '1', name: 'John Doe' },
    { id: '2', name: 'Jane Smith' },
    { id: '3', name: 'Alice Johnson' },
];

export const Room = () => {
    const [rooms, setRooms] = useState([]);
    const [roomDetails, setRoomDetails] = useState({
        roomNumber: '',
        type: '',
        pricePerNight: '',
        isAvailable: true,
        rentedBy: '',
        rentedAt: ''
    });
    const [editIndex, setEditIndex] = useState(-1);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRoomDetails({ ...roomDetails, [name]: value });
    };

    const handleAddRoom = () => {
        if (editIndex >= 0) {
            const updatedRooms = [...rooms];
            updatedRooms[editIndex] = roomDetails;
            setRooms(updatedRooms);
            setEditIndex(-1);
        } else {
            setRooms([...rooms, roomDetails]);
        }
        setRoomDetails({
            roomNumber: '',
            type: '',
            pricePerNight: '',
            isAvailable: true,
            rentedBy: '',
            rentedAt: ''
        });
    };

    const handleEdit = (index) => {
        setRoomDetails(rooms[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setRooms(rooms.filter((_, i) => i !== index));
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Room Management
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Room Number"
                        name="roomNumber"
                        value={roomDetails.roomNumber}
                        onChange={handleChange}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Type"
                        name="type"
                        value={roomDetails.type}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Price Per Night"
                        name="pricePerNight"
                        value={roomDetails.pricePerNight}
                        onChange={handleChange}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                        <InputLabel>Rented By (Customer ID)</InputLabel>
                        <Select
                            name="rentedBy"
                            value={roomDetails.rentedBy}
                            onChange={handleChange}
                            label="Rented By (Customer ID)"
                        >
                            {dummyCustomers.map((customer) => (
                                <MenuItem key={customer.id} value={customer.id}>
                                    {customer.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Rented At"
                        name="rentedAt"
                        value={roomDetails.rentedAt}
                        onChange={handleChange}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddRoom}
                        sx={{ mt: 2, display: 'block', margin: '0 auto', backgroundColor: 'orange' }}
                    >
                        {editIndex >= 0 ? 'Save Room' : 'Add Room'}
                    </Button>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Room Number</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Price Per Night</TableCell>
                            <TableCell>Rented By</TableCell>
                            <TableCell>Rented At</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rooms.map((room, index) => (
                            <TableRow key={index}>
                                <TableCell>{room.roomNumber}</TableCell>
                                <TableCell>{room.type}</TableCell>
                                <TableCell>{room.pricePerNight}</TableCell>
                                <TableCell>{dummyCustomers.find(customer => customer.id === room.rentedBy)?.name || 'N/A'}</TableCell>
                                <TableCell>{room.rentedAt}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEdit(index)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDelete(index)} color="error">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default Room;
